module.exports = __webpack_public_path__ + "img/icon-broadcast.9604789f.svg";